// stu#den    Stu@den
export default 'Stu@denenglsd'.substring(0, 7);
